/**
 * Every committed coin mark, keyed by lowercased base currency.
 *
 * 🔴 **This replaces a hand-maintained `HAVE_MARK` set, and the set was a real hazard.** It
 * carried 43 tickers with the instruction *"regenerate with `ls web/public/coins`"*, so the
 * directory and the list were two records of one fact. Forgetting the second step produces a
 * coin that has a mark on disk and renders a monogram — invisible, because a monogram is a
 * legitimate state, so nothing looks broken and nobody investigates.
 *
 * `import.meta.glob` makes the directory the single source of truth. Vite returns a URL per
 * file, and **splits them by size on its own**: measured on the 73-file set, the 57 at or above
 * the 4 KB `assetsInlineLimit` are emitted as fingerprinted files and the 16 below it become
 * base64 data URIs in the bundle. That is the right split and not one worth overriding — the
 * small ones are flat two-colour art whose whole payload is smaller than the request that would
 * fetch it, and the large ones stay cacheable.
 *
 * ⚠ Worth stating because the first version of this comment claimed *"nothing is inlined"*,
 * which the build disproved in one line: `grep -c "data:image/png;base64" dist/assets/index-*.js`
 * returned 16.
 *
 * Deleting `assets/coins/` — see its `PROVENANCE.md` for when that might be necessary — leaves
 * this an empty map and every coin on the monogram. It does not break the build.
 */

const modules = import.meta.glob<string>('../assets/coins/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
});

const urls: Record<string, string> = {};
for (const [path, url] of Object.entries(modules)) {
  const name = path.split('/').pop()?.replace(/\.png$/, '');
  if (name) urls[name.toLowerCase()] = url;
}

export default urls;
